import { ReactNode } from 'react';

import { styled } from '@material-ui/core';

import { ChartGraphic } from '../ChartGraphic';

const PositionedChart = styled(ChartGraphic)({
  position: 'fixed',
});

const BackgroundWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  overflow: 'auto',
  background: theme.palette.background.default,
}));

export const ChartBackground = ({ children }: { children: ReactNode }) => (
  <BackgroundWrapper>
    <PositionedChart />
    {children}
  </BackgroundWrapper>
);
